import { useState, useEffect } from 'react'
import { Button, Spinner } from 'react-bootstrap'
import { Switch } from 'components/common'
import { UserSettingsServices } from 'services'
import { toast } from 'components/common/Toast'
import { LeftArrow } from 'assets/icons/components/index'
import { setMainContent } from 'actions'
import { connect } from 'react-redux'

const ContentSettings = (props) => {
  const { dispatch } = props
  const [isLoading, setIsLoading] = useState(false)
  const [isLoadingFetch, setIsLoadingFetch] = useState(false)
  const [inputValues, setInputValues] = useState({
    not_dubious_content: false,
    quick_connection: false
  })

  useEffect(() => {
    fetchSettings()
  }, [])

  const fetchSettings = async () => {
    setIsLoadingFetch(true)
    let { data, error } = await UserSettingsServices.GET_CONTENT_SETTINGS()
    if (data) {
      let { not_dubious_content, quick_connection } = data
      setInputValues({
        not_dubious_content: not_dubious_content || false,
        quick_connection: quick_connection || false
      })
    }
    if (error) {
      console.log(error?.message)
    }
    setIsLoadingFetch(false)
  }

  const handleOnChange = event => {
    const value = event.target.checked
    const id = event.target.id
    setInputValues({ ...inputValues, [id]: value })
  }

  const handleSubmit = async () => {
    try {
      setIsLoading(true)
      let payload = inputValues

      let { data, error } = await UserSettingsServices.UPDATE_CONTENT_SETTINGS(payload)
      if (data) {
        toast.success('Update content settings successfully')
      }
      if (error) {
        throw error?.message
      }
    } catch (error) {
      toast.error(error)
    }
    setIsLoading(false)
  }

  let settings = [
    {
      name: 'not_dubious_content',
      label: 'Do not show dubious content',
      value: inputValues.not_dubious_content
    },
    {
      name: 'quick_connection',
      label: 'Allow quick connection',
      value: inputValues.quick_connection
    },
  ]

  const back = () => {
    dispatch(setMainContent('dashboard'))
  }

  return (
    <div className='main-content__content-settings'>
      <div className='content-settings__header'>
        <div className='header__heading'>Content Settings</div>
        <div className='header__icon' onClick={() => back()}>
          <LeftArrow className='icon__icon' />
        </div>
      </div>
      <div className='content-settings__container'>
        {settings.map(setting => (
          <div className='container__option' key={setting.name}>
            <div className='option__label'>
              {setting.label}
            </div>
            <Switch value={setting.value} id={setting.name} handleOnChange={handleOnChange} />
          </div>
        ))}
        <Button
          variant='primary'
          size='lg'
          className='form__button'
          style={{ magrinTop: '1rem' }}
          onClick={() => handleSubmit()}>
          {isLoading ? <Spinner
            as='span' animation='border' size='md' role='status'
          /> : 'Save'}
        </Button>
        {isLoadingFetch && <div className='main-content__setting-loading-overlay'>
          <Spinner
            as='span' animation='border' size='md' role='status' variant='secondary'
          />
        </div>}
      </div>
    </div >
  )
}


export default connect(null)(ContentSettings)
